import React from 'react'
import Bathtub from '@material-ui/icons/Bathtub'

export default function BathtubIcon(props) {
    const { ...other } = props

    return (
        <Bathtub {...other} />
    )
}